import "./ProgressBar.scss";
import { useState, useEffect } from "react";
import Box from "../layout/Box";

// Step 1: 3 questions
// Step 2: 5 questions
// Step 3: 4 questions

// total: 12

// Custom hook to get window width
function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // Empty dependency array to run effect only once

  return width;
}

type ProgressBarProps = {
  color?: "primary" | "secondary" | "muted";
  dynNumber?: number;
};
const ProgressBar = ({
  color = "primary",
  dynNumber = 10
}: ProgressBarProps) => {

  const windowWidth = useWindowWidth();
  // Example condition based on window width
  const shouldDisplayComponent = windowWidth > 600; // Example threshold


  const colorClass = `ProgressBar--color-${color}`;
  // const colorClass = `Button--color-${color}`;
  // const colorDisabledClass = disabled ? `${colorClass}--disabled` : undefined;
  const ProgressBarClasses = ["ProgressBar", colorClass]
    .filter((className) => className)
    .join(" ");

  let finalNumber = 0;

  let wid;

  if (shouldDisplayComponent) {
    wid = 400;

    if (dynNumber < 400) {
      finalNumber = dynNumber;
    } else {
      finalNumber = 400;
    }

  } else {
    wid = 200;

    if (dynNumber < 200) {
      finalNumber = dynNumber/2;
    } else {
      finalNumber = 200;
    }
  }

  return (
    <Box className={ProgressBarClasses}>
    <svg width={wid} height="20" xmlns="http://www.w3.org/2000/svg">
      <rect width={wid} height="20" x="0" y="0" rx="12" ry="12" fill="var(--color-n-200)" />
      <rect width={finalNumber} height="20" x="0" y="0" rx="12" ry="12" fill="var(--color-primary)" />
    </svg>  
    </Box>
  );
};

export default ProgressBar;